import type {Commit} from '../../types/shared'
import {ListView} from '@github-ui/list-view'
import {CommitRow} from './CommitRow'
import type {Repository} from '@github-ui/current-repository'
import {Panel} from '../Panel'
import {useId} from 'react'
import {TimelineRow} from './TimelineRow'

export type CommitGroupProps = {
  buildCommitPath?: (args: {owner: string; repo: string; commitish: string}) => string
  repo: Repository
  commits: Commit[]
  title: string
  shouldClipTimeline: boolean
  currentBlobPath?: string
}

/**
 * See ListView stories for a representation of this component.
 * ui/packages/list-view/src/stories/Commits.stories.tsx
 * https://ui.githubapp.com/storybook/?path=/story/recipes-listview-dotcom-pages--commits
 */
export function CommitGroup({
  buildCommitPath,
  commits,
  title,
  shouldClipTimeline,
  repo,
  currentBlobPath = '',
}: CommitGroupProps) {
  const groupId = useId()

  return (
    <>
      <TimelineRow clipTimeline={shouldClipTimeline ? 'top' : 'none'}>
        <TimelineRow.Heading as="h3" id={groupId} title={`Commits on ${title}`} data-testid="commit-group-title" />
      </TimelineRow>
      <Panel>
        <ListView key={title} title={title} titleHeaderTag="h3" ariaLabelledBy={groupId}>
          {commits.map(commit => {
            return (
              <CommitRow
                key={commit.oid}
                buildCommitPath={buildCommitPath}
                commit={commit}
                repo={repo}
                path={currentBlobPath}
              />
            )
          })}
        </ListView>
      </Panel>
    </>
  )
}

try{ CommitGroup.displayName ||= 'CommitGroup' } catch {}